export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ta akcja trwale usunie aktywo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czy na pewno chcesz kontynuować?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tak"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie będziesz już widzieć tego aktywa na swojej liście."])}
}